import React from "react";
import { gtag } from "ga-gtag";
import { Dimensions, View, Button, Text, useWindowDimensions } from "react-native";
// import { createDrawerNavigator, DrawerContentComponentProps } from "@react-navigation/drawer";
import RDrawer from '@src/components/drawer'
import { RDrawerProvider, useRDrawer } from '@src/components/drawer/provider';
import { DrawerProvider } from "./drawer-provider";
import PopupMenuProvider from "@src/components/popup-menu/provider";
import { useAppSelector } from "@src/ducks/ducksHook";
import { selectedAuthGuestRole } from "@src/ducks/slices/auth.slice";

import MainScreen from "./main-screen";
import DrawerGuest from "screens/guest-screen/drawer-component";
import DrawerComponent from "./drawer-component";
import { largeSize, tabletSize, mobileSize } from "@src/utils/screensize-helper";

const initializeWidth = Dimensions.get('window').width;
// const Drawer = createDrawerNavigator();

const CustomDrawerContent = () => {
  const isGuest = useAppSelector(selectedAuthGuestRole);
  return isGuest ? <DrawerGuest /> : <DrawerComponent />;
};

function AppContent() {
  const {
    isVisible,
    openDrawer,
    closeDrawer,
    drawerWidth,
    headerHeight,
  } = useRDrawer();

  // Suppose you have your device size detection logic here:
  const isTabletSize = tabletSize(); // your actual logic
  const isMobileSize = mobileSize(); // your actual logic


  if (isTabletSize || isMobileSize) {
    return (
      <RDrawer
        drawerWidth={drawerWidth}
        headerHeight={75.4}
        isVisible={isVisible}
        onClose={closeDrawer}
        drawerContent={<CustomDrawerContent />}
      >
        <View style={{ flex: 1 }}>
          <MainScreen />
        </View>
      </RDrawer>
    );
  } else {
    closeDrawer();
    return <MainScreen />;
  }
}



const DrawerScreen = () => {
  React.useEffect(() => {
    // Fire your analytics event once
    gtag("event", "homepage");
  }, []);

  return (
    <DrawerProvider>
      <PopupMenuProvider>
         <RDrawerProvider initialHeaderHeight={50}>
          <AppContent />
        </RDrawerProvider>
     </PopupMenuProvider>
    </DrawerProvider>
  );
};

export default DrawerScreen;
